import envUtil from "./envUtil";

const loadKakaoMapScript = (): Promise<typeof window.kakao> => {
  return new Promise((resolve, reject) => {
    try {
      if (window.kakao && window.kakao.maps) {
        resolve(window.kakao);
        return;
      }

      const script = document.createElement("script");
      script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${envUtil.KAKAO_KEY}&autoload=false&libraries=services`;
      script.async = true;
      script.onload = () => {
        window.kakao.maps.load(() => resolve(window.kakao));
      };
      script.onerror = reject;
      document.head.appendChild(script);
    } catch (error) {
      console.error("loadKakaoMapScript error", error);
      reject();
    }
  });
};

export default loadKakaoMapScript;
